import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type DmpRetrievalContext from 'parog-web/contexts/dmp-retrieval-context';
import Button from 'ui-kit/components/button';
import Checkbox from 'ui-kit/components/checkbox';

interface Args {
  context: DmpRetrievalContext;
  onDismiss: () => void;
}
export default class DmpAccessFormSetSecretConnectionComponent extends Component<Args> {
  @tracked isSecretConnection = false;

  onSubmit = async (event: Event): Promise<void> => {
    event.preventDefault();
    this.args.context.isSecretConnection = this.isSecretConnection;
    await this.args.context.transitionTo();
  };

  <template>
    <div data-test-secret-connection-state>
      <form {{on 'submit' this.onSubmit}} class='ui form'>
        <div class='field'>
          <p>
            Le patient pour lequel vous souhaitez récupérer l'historique de
            remboursement est mineur.<br />
            Cochez la case ci-dessous si vous souhaitez accéder au DMP en mode
            "connexion secrète".
          </p>
          <Checkbox
            @labelName='Connexion secrète'
            @checked={{this.isSecretConnection}}
            @onChange={{fn (mut this.isSecretConnection)}}
            @dataTestInput='secretConnection'
          />
        </div>

        <div class='form-buttons'>
          <Button
            type='button'
            class='ui fluid form-button'
            {{on 'click' @onDismiss}}
          >
            Annuler
          </Button>
          <Button
            data-test-button='submit-dmp-access-form'
            type='submit'
            class='ui fluid primary form-button'
          >
            Continuer
          </Button>
        </div>
      </form>
    </div>
  </template>
}
